<template>
	<div>
		<TilteParallax>
			<div class="d-flex align-center">
				<div :class="[
					'd-flex',
					$vuetify.breakpoint.smAndDown
						? 'flex-column'
						: 'flex-row align-center',
				]">
					<h1 class="display-1 font-weight-thin">
						Pedido
					</h1>

					<div :class="[
						'd-flex align-center',
						$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-2',
					]">
						<!-- <v-chip
							class="ml-2 white--text"
							color="orange"
							v-if="salesOrder"
						>
							{{ salesOrder.status.name }}
						</v-chip> -->

						<ChipStatus :status="salesOrder.status" v-if="salesOrder" />
					</div>
				</div>
			</div>

			<template v-slot:subtitle>
				{{ `Pedido: #${$route.params.id}` }}

				<template v-if="salesOrder">
					<small>
						{{ salesOrder.customer.name }}
					</small>
				</template>
			</template>

			<template v-slot:menu>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="default" fab :loading="ui.exporting" v-bind="attrs" v-on="on" elevation="5">
							<v-icon>
								mdi-dots-vertical
							</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template v-if="salesOrder">
							<v-list-item @click="receive()" v-if="salesOrder.status_id == 1">
								<v-list-item-title>
									Recibir pedido
								</v-list-item-title>
							</v-list-item>

							<template v-if="salesOrder.status_id == 2">
								<v-list-item v-if="ui.type == 'show'" @click="ui.type = 'edit'">
									<v-list-item-title>
										Editar
									</v-list-item-title>
								</v-list-item>

								<v-list-item v-if="ui.type == 'edit'" @click="cancel()">
									<v-list-item-title>
										Cancelar edición
									</v-list-item-title>
								</v-list-item>

								<!-- <v-list-item
									@click="formatOpen()"
									v-if="ui.type == 'show'"
								>
									<v-list-item-title>
										Ver formato
									</v-list-item-title>
								</v-list-item> -->

								<v-list-item @click="exportSelectedToTemplate()" v-if="ui.type == 'show'">
									<v-list-item-title>
										Exportar
									</v-list-item-title>
								</v-list-item>
							</template>
						</template>
					</v-list>
				</v-menu>
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row justify="center">
				<v-col cols="12" md="10">
					<v-card outlined :class="[
						'pt-0',
						$vuetify.breakpoint.smAndDown ? 'pa-0' : 'pa-4',
					]" :loading="ui.geting">
						<v-card-text :class="[{ 'pa-1': $vuetify.breakpoint.smAndDown }]">
							<v-container fluid>
								<CreateUpdate v-if="salesOrder" :salesorder="salesOrder" :type="ui.type"
									@cancel="cancel()" @get="get()" @updated="updated()" @created="$router.go(-1)">
								</CreateUpdate>
							</v-container>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- SalesOrdersStatusUpdate Component -->
		<SalesOrdersStatusUpdate />
	</div>
</template>

<script>
import { v } from "@/main";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
import { EventBus } from "@/main";
import SalesOrder from "@/clas/SalesOrder";
import TilteParallax from "@/components/TilteParallax";
import CreateUpdate from "@/components/SalesOrder/CreateUpdate";
import SalesOrdersStatusUpdate from "@/components/SalesOrder/StatusUpdate";

// Class
import Csv from "@/../../GeneralComponents/Class/Csv";

// Components
import ChipStatus from "@/components/SalesOrder/ChipStatus";

export default {
	name: "Create",

	components: {
		TilteParallax,
		CreateUpdate,
		SalesOrdersStatusUpdate,
		ChipStatus,
	},

	data() {
		return {
			salesOrder: null,

			layout: {
				notify: false,
				status_id: 2,
			},

			ui: {
				type: "show",

				exporting: false,

				geting: true,

				receiving: false,

				dialogs: {
					receive: false,
				},
			},
		};
	},

	created() {
		this.get();

		this.$store.dispatch("getCustomers");

		EventBus.$on("SalesOrdersStatusUpdated", () => {
			this.get();
		});
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;

				let resp = await axios.get(
					`${process.env.VUE_APP_API_SERVER}/auth/salesorder/${this.$route.params.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.acount.token}`,
						},
					}
				);

				this.salesOrder = {
					...resp.data.data,
					articles: resp.data.data.articles_with.map((article) => {
						return {
							...article,
							...{
								...article.pivot,
							},
							id: article.id,
						};
					}),
				};

				this.$store.dispatch(
					"getArticles",
					this.salesOrder.customer.id
				);
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.geting = false;
			}
		},

		async cancel() {
			if (confirm(`¿Quieres cancelar la edición de este registro?`)) {
				await this.get();

				this.ui.type = "show";

				EventBus.$emit("Snackbar", {
					text: "Actualización cancelada.",
					type: "secondary",
				});
			}
		},

		async updated() {
			this.ui.type = "show";

			await this.get();
		},

		async receive() {
			EventBus.$emit("SalesOrdersStatusUpdate", [
				Object.assign({}, this.salesOrder),
			]);
		},

		async exportSelectedToTemplate() {
			try {
				this.ui.exporting = true;

				let salesOrder = new SalesOrder(this.salesOrder);

				let csv = new Csv(salesOrder.templateCreate());

				await csv.toCsv({
					name: `Template OV ${this.salesOrder.id}}`,
				});

				csv.csvDownload();

				await salesOrder.exportedUpdate();
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.exporting = false;
			}
		},

		formatOpen() {
			window.open(
				`${process.env.VUE_APP_API_SERVER}/salesorder/${this.salesOrder.id}/format`,
				"_blank"
			);
		},
	},

	computed: {
		...mapState(["acount"]),
	},
};
</script>

<style lang="css" scoped></style>
